/* ============================================================
   GlamourGallery — Product Detail Page JS
   Sentinel: gg-section-product-v1
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    /* ── Move delivery line after buy-buttons ──────────────── */
    /* Horizon renders buy-buttons under several different elements
       depending on theme version: <buy-buttons>, .buy-buttons,
       .buy-buttons-block wrapper, product-form-component, or as a
       data-block. Try them in order so we still land in the right
       place on the current Horizon 3.x and future theme updates. */
    function findBuyAnchor() {
      return document.querySelector('buy-buttons')
          || document.querySelector('.buy-buttons')
          || document.querySelector('.buy-buttons-block')
          || document.querySelector('product-form-component')
          || document.querySelector('[data-block-type="_buy-buttons"]')
          || null;
    }
    const deliveryLine = document.getElementById('gg-delivery-line');
    if (deliveryLine) {
      const target = findBuyAnchor();
      if (target) {
        target.insertAdjacentElement('afterend', deliveryLine);
        deliveryLine.style.display = '';
        deliveryLine.removeAttribute('aria-hidden');
      } else {
        /* Fallback: show inline where it was injected */
        deliveryLine.style.display = '';
        deliveryLine.removeAttribute('aria-hidden');
      }
    }

    /* ── Move dimensions caption beneath delivery line ─────
       Anchored to deliveryLine if it was relocated; otherwise falls back
       to the buy-buttons anchor so the cluster stays
       Add-to-Basket → Delivery → Dimensions on every market. Hidden until
       moved to avoid flash of unstyled content at the bottom of the section. */
    const dims = document.getElementById('gg-product-dims');
    if (dims) {
      const anchor = (deliveryLine && deliveryLine.parentNode) ? deliveryLine : findBuyAnchor();
      if (anchor) {
        anchor.insertAdjacentElement('afterend', dims);
        dims.style.display = '';
        dims.removeAttribute('aria-hidden');
      } else {
        dims.style.display = '';
        dims.removeAttribute('aria-hidden');
      }
    }

    /* ── PDP rating injection (tight, user-confirmed selector) ─────
       The right column of the PDP is a .group-block-content.layout-panel-flex--column
       (a flex column with 12px gap). There can be multiple such elements
       on the PDP; the right column is the one whose direct children include
       a .divider element. Insert the rating wrap as the previous sibling
       of that divider — same flex-column row, lands above the line. */
    const ratingWrap = document.getElementById('gg-pdp-rating-wrap');
    if (ratingWrap) {
      const candidates = document.querySelectorAll('.group-block-content.layout-panel-flex--column');
      let divider = null;
      for (const c of candidates) {
        const d = Array.from(c.children).find(ch => /(^|\s)divider/.test(ch.className || ''));
        if (d) { divider = d; break; }
      }
      if (divider) {
        divider.insertAdjacentElement('beforebegin', ratingWrap);
        // Parent has gap: 12px between children — pull the rating row
        // tighter to its neighbours so the price → rating → divider/qty
        // flow feels like one cluster, not three separated rows.
        ratingWrap.style.cssText = 'display:block;width:100%;margin:-8px 0 -6px;';
        ratingWrap.removeAttribute('aria-hidden');
      }
    }

    /* ── Inject product type eyebrow above h1 ─────────────── */
    /* Product pages only — guard so the blog/page <h1> is never touched
       (the old og:type fallback leaked "website" above the Journal title). */
    const onProductPage = !!(document.querySelector('product-information, .product-information, buy-buttons, product-form-component')
      || /template-product/.test(document.body.className));
    const productType = document.querySelector('.product-type, [itemprop="category"]');
    const h1 = onProductPage ? document.querySelector('.product-details h1, [data-testid] h1') : null;
    if (h1 && !document.querySelector('.gg-product-eyebrow')) {
      const type = productType?.textContent?.trim() || '';
      if (type && type !== 'product') {
        const eyebrow = document.createElement('span');
        eyebrow.className = 'gg-product-eyebrow';
        eyebrow.textContent = type;
        h1.insertAdjacentElement('beforebegin', eyebrow);
      }
    }

    /* ── Smooth scroll to reviews section ─────────────────── */
    document.querySelectorAll('[data-scroll-to-reviews]').forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector('.gg-reviews, #gg-reviews-list');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ── Delivery date estimator — DISABLED ─────────────────
       Previously overwrote the Liquid copy with a UK-locale "3–7 working
       day" arrival window. Misleading on two counts: real CJ delivery is
       2–4 weeks, and the en-GB date format is wrong for non-UK visitors.
       Liquid now renders country-aware text (see sections/product-information.liquid)
       so we let that stand. */
  });

})();
